import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';
export type ThemeColor = 'blue' | 'deep-purple' | 'pink' | 'orange' | 'green';
export type ThemeModel = 'light' | 'dark';
@Injectable({
	providedIn: 'root'
})
export class ThemeService {
	private _theme = new BehaviorSubject<string>(localStorage.getItem('theme'));
	theme: Observable<{
		name: string;
		color: ThemeColor;
		model: ThemeModel;
	}> = this._theme.pipe(
		tap(v => {
			localStorage.setItem('theme', v);
		}),
		map(v => {
			switch (v) {
				case 'blue-light-theme':
					return {
						name: v,
						color: 'blue',
						model: 'light'
					};

				case 'blue-dark-theme':
					return {
						name: v,
						color: 'blue',
						model: 'dark'
					};
				case 'deep-purple-light-theme':
					return {
						name: v,
						color: 'deep-purple',
						model: 'light'
					};

				case 'deep-purple-dark-theme':
					return {
						name: v,
						color: 'deep-purple',
						model: 'dark'
					};

				case 'pink-light-theme':
					return {
						name: v,
						color: 'pink',
						model: 'light'
					};

				case 'pink-dark-theme':
					return {
						name: v,
						color: 'pink',
						model: 'dark'
					};

				case 'orange-light-theme':
					return {
						name: v,
						color: 'orange',
						model: 'light'
					};

				case 'orange-dark-theme':
					return {
						name: v,
						color: 'orange',
						model: 'dark'
					};

				case 'green-light-theme':
					return {
						name: v,
						color: 'green',
						model: 'light'
					};

				case 'green-dark-theme':
					return {
						name: v,
						color: 'green',
						model: 'dark'
					};

				default:
					return {
						name: v,
						color: 'blue',
						model: 'light'
					};
			}
		})
	);
	setTheme(val: string) {
		this._theme.next(val);
	}
}
